import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.992 0C18.5677 0 24 5.39166 24 11.9014C23.991 18.7929 18.8025 24.0179 11.9741 24C5.14568 23.982 -0.0338855 18.7051 0.000166934 11.8387C0.0306349 5.36657 5.46828 0 11.992 0ZM11.9741 21.0058C16.901 21.0201 20.9353 17.0834 20.9514 12.2526C20.9657 6.96669 17.2164 3.08735 12.0745 3.06943C6.93254 3.05151 3.04159 6.9201 3.02905 12.0179C3.02291 13.1963 3.24982 14.3643 3.69673 15.4547C4.14364 16.5451 4.80175 17.5365 5.6332 18.3718C6.46465 19.207 7.45304 19.8697 8.54155 20.3218C9.63006 20.7738 10.7972 21.0063 11.9759 21.0058H11.9741Z"
      fill="#E8726A"
    />
    <path
      d="M14.7537 16.3346C13.9257 16.2522 13.345 16.0748 12.8091 16.1662C11.9738 16.285 11.1619 16.5322 10.4022 16.899C9.38955 17.4276 8.54003 17.4366 8.03282 16.6786C7.49515 15.8705 7.75861 14.9943 8.76047 14.3618C10.6961 13.1415 12.7697 12.7384 14.9939 13.3834C15.8756 13.6379 16.2735 14.3062 16.1194 15.143C16.074 15.473 15.9107 15.7754 15.6597 15.9944C15.4086 16.2134 15.0869 16.3343 14.7537 16.3346Z"
      fill="#E8726A"
    />
    <path
      d="M8.963 7.52934C9.36825 7.52634 9.7586 7.68192 10.0506 7.96283C10.3427 8.24375 10.5132 8.62773 10.5258 9.0327C10.5006 9.42133 10.3369 9.78804 10.0642 10.0662C9.79159 10.3444 9.4282 10.5155 9.04007 10.5486C8.65097 10.5441 8.27788 10.3931 7.9952 10.1257C7.71251 9.85837 7.541 9.49432 7.51488 9.10616C7.49803 8.9057 7.52294 8.70393 7.58804 8.51358C7.65314 8.32323 7.75701 8.14845 7.89309 8.00027C8.02918 7.85209 8.19452 7.73373 8.37867 7.65268C8.56283 7.57162 8.76179 7.52962 8.963 7.52934Z"
      fill="#E8726A"
    />
    <path
      d="M14.9558 10.5324C14.5501 10.5208 14.1649 10.3514 13.8821 10.0603C13.5994 9.7692 13.4412 9.37933 13.4414 8.97353C13.475 8.58624 13.6496 8.22473 13.932 7.95755C14.2145 7.69036 14.5851 7.53607 14.9738 7.52393C15.1753 7.52379 15.3748 7.56429 15.5603 7.64303C15.7458 7.72176 15.9135 7.83709 16.0534 7.98213C16.1933 8.12716 16.3024 8.29893 16.3744 8.48713C16.4463 8.67533 16.4796 8.87611 16.4721 9.07745C16.4559 9.46869 16.2891 9.83854 16.0065 10.1097C15.724 10.3808 15.3475 10.5323 14.9558 10.5324Z"
      fill="#E8726A"
    />
  </svg>
);
const IconNegative = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconNegative;
